import { createFileRoute } from '@tanstack/react-router';
import { requireAuth } from '../lib/requireAuth';
import DeploymentComponent from '../components/DeploymentComponent';
import { usePageMeta } from '../hooks/usePageMeta';
import { AdminNav } from '../components/AdminNav';

export const Route = createFileRoute('/deploy')({
  beforeLoad: () => requireAuth('/deploy'),
  component: DeployPage,
});

function DeployPage() {
  usePageMeta('Deploy | Boyden Renovations', undefined, true);

  return (
    <div>
      <AdminNav />
      <DeploymentComponent />
    </div>
  );
}
